module.exports = __webpack_public_path__ + "static/media/entertainer_artist.41ad7be2.webp";